import type { ShareLinkAttribution } from './report-share-attribution';

/**
 * Service for creating and managing share links
 */
export interface ShareLinkService {
    /**
     * Create a share link for a given task
     *
     * @param password - Optional password for protected sharing
     * @returns Promise resolving to the share ID
     * @throws Error if the share link creation fails
     */
    createShareLink(password?: string): Promise<string>;

    /**
     * 使用已有 shareId 构造当前报告的分享 URL，不重复创建分享记录。
     *
     * @param shareId 分享 ID。
     * @param attribution 可选的注册归因信息。
     */
    buildShareUrl(shareId: string, attribution?: ShareLinkAttribution): string;

    /**
     * 构造当前 Viewer 可继续转发的分享 URL。
     *
     * 完整的分享注册归因会被转换为链接来源；历史地址保持原有参数。
     */
    buildForwardShareUrl(): string;
}

/**
 * Symbol for dependency injection of ShareLinkService
 */
export const ShareLinkService = Symbol.for('ShareLinkService');
